export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11256.193e0dbc.jpg";